<div class="d-flex align-items-center pb-3" mat-dialog-title>
    <div class="spacer title">Oude toolboxen</div>
    <div>
        <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>
<div class="dialog-content" mat-dialog-content>
    <table class="table table-hover">
        <thead>
            <tr>
                <th>Toolbox</th>
                <th>Van</th>
                <th>Tot</th>
            </tr>
        </thead>
        <tbody>
            @for (toolbox of toolboxes; track toolbox) {
                <tr class="curpoint" (click)="open(toolbox)">
                    <td>
                        {{ toolbox?.name }}
                    </td>
                    <td>
                        {{ toolbox.begindate | date: 'EEE d MMMM yyyy' }}
                    </td>
                    <td>
                        {{ toolbox.enddate | date: 'EEE d MMMM yyyy' }}
                    </td>
                </tr>
            } @empty {
                <tr>
                    <td class="text-center" colspan="3">Geen toolboxen gevonden</td>
                </tr>
            }
            @if (loading) {
                <tr>
                    <td class="text-center" colspan="3">Bezig met laden...</td>
                </tr>
            }
        </tbody>
    </table>
</div>
